/* CHAOS Type Chips — keep the active chip in sync with the URL.
   The chips themselves are server-rendered, but Clean Canvas's filter
   sidebar uses the Section Rendering API (pushState/replaceState) to
   update filters without a full reload. Without this script, clearing
   a product_type filter via the sidebar would leave the chip stuck
   highlighted until the next full page load. */
(function () {
  var PARAM = 'filter.p.product_type';

  function activeTypeFromUrl() {
    try {
      return new URLSearchParams(window.location.search).get(PARAM) || '';
    } catch (e) {
      return '';
    }
  }

  function chipType(chip) {
    try {
      var url = new URL(chip.getAttribute('href'), window.location.origin);
      return url.searchParams.get(PARAM) || '';
    } catch (e) {
      return '';
    }
  }

  function syncChips(scope) {
    var active = activeTypeFromUrl();
    (scope || document).querySelectorAll('.cf-tc__chip').forEach(function (chip) {
      var isActive = chipType(chip) === active;
      chip.classList.toggle('cf-tc__chip--active', isActive);
      if (isActive) {
        chip.setAttribute('aria-current', 'page');
      } else {
        chip.removeAttribute('aria-current');
      }
    });
  }

  function patchHistory() {
    if (window.__cfTcHistoryPatched) return;
    window.__cfTcHistoryPatched = true;
    ['pushState', 'replaceState'].forEach(function (method) {
      var original = history[method];
      history[method] = function () {
        var result = original.apply(history, arguments);
        window.dispatchEvent(new Event('cf-tc:locationchange'));
        return result;
      };
    });
  }

  /* --- Slider arrows --- */
  function initSlider(section) {
    var rail = section.querySelector('[data-cf-tc-rail]');
    var prev = section.querySelector('[data-cf-tc-prev]');
    var next = section.querySelector('[data-cf-tc-next]');
    if (!rail || !prev || !next) return;

    function step(dir) {
      var amount = Math.max(160, rail.clientWidth * 0.6);
      rail.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    function syncDisabled() {
      var canScroll = rail.scrollWidth - rail.clientWidth > 1;
      // Hide both buttons entirely when nothing overflows (low-cardinality
      // categories like a 4-chip Reels). Reveals fade out arrows when
      // there's something to scroll to.
      if (!canScroll) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }
      prev.hidden = false;
      next.hidden = false;
      prev.disabled = rail.scrollLeft <= 1;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    rail.addEventListener('scroll', syncDisabled, { passive: true });
    window.addEventListener('resize', syncDisabled);
    requestAnimationFrame(syncDisabled);
  }

  function initAllSliders(scope) {
    (scope || document).querySelectorAll('.cf-tc').forEach(initSlider);
  }

  function init() {
    patchHistory();
    syncChips();
    initAllSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('popstate', function () { syncChips(); });
  window.addEventListener('cf-tc:locationchange', function () { syncChips(); });
  document.addEventListener('shopify:section:load', function (e) {
    syncChips(e.target);
    initAllSliders(e.target);
  });
})();
